import { SoundEffect } from "@hg/media"

import SFXBuff from "../../../assets/audio/sfx/buff.mp3"
import SFXCommonClick from "../../../assets/audio/sfx/commonClick.mp3"
import SFXCraft from "../../../assets/audio/sfx/craft.mp3"
import SFXDamaged from "../../../assets/audio/sfx/damaged.mp3"
import SFXDebuff from "../../../assets/audio/sfx/debuff.mp3"
import SFXHeal from "../../../assets/audio/sfx/heal.mp3"
import SFXHurt from "../../../assets/audio/sfx/hurt.mp3"
import SFXOpenDoor from "../../../assets/audio/sfx/openDoor.mp3"
import SFXShield from "../../../assets/audio/sfx/shield.mp3"
import SFXSmallClick from "../../../assets/audio/sfx/smallClick.mp3"

export const SFX = new SoundEffect({
    effectsDict: {
        commonClick: SFXCommonClick,
        smallClick: SFXSmallClick,
        craft: SFXCraft,
        damaged: SFXDamaged,
        heal: SFXHeal,
        hurt: SFXHurt,
        OpenDoor: SFXOpenDoor,
        shield: SFXShield,
        buff: SFXBuff,
        debuff: SFXDebuff,
    },
    volume: 1,
})
